import { render, staticRenderFns } from "./ReviewCaseDetail.vue?vue&type=template&id=8d466532&scoped=true"
import script from "./ReviewCaseDetail.vue?vue&type=script&lang=js"
export * from "./ReviewCaseDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewCaseDetail.vue?vue&type=style&index=0&id=8d466532&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d466532",
  null
  
)

export default component.exports